"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = tslib_1.__importStar(require("@antv/util"));
var plot_1 = tslib_1.__importDefault(require("../../base/plot"));
var layer_1 = tslib_1.__importDefault(require("./layer"));
var Pie = /** @class */ (function (_super) {
    tslib_1.__extends(Pie, _super);
    function Pie() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Pie.prototype.createLayers = function (props) {
        var layerProps = _.deepMix({}, props);
        layerProps.type = 'pie';
        _super.prototype.createLayers.call(this, layerProps);
    };
    Pie.getDefaultOptions = layer_1.default.getDefaultOptions;
    return Pie;
}(plot_1.default));
exports.default = Pie;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/pie/index.js
// module id = 949
// module chunks = 37